import type { ComplexAttributeConverter } from 'lit'

export const explicitBooleanAttributeConverter: ComplexAttributeConverter<boolean, Boolean> = {
  fromAttribute(value, type) {
    return value === 'true'
  },
  toAttribute(value, type) {
    return value ? 'true' : 'false'
  }
};